//DROPDOWN DATA
export const companyNameArr = [
    {key: 'ENCON_GROUP', text: 'ENCON Group'},
    {key: 'ENCON_INDIA', text: 'ENCON (India)'},
    {key: 'ENCON_ENGNR', text: 'ENCON Engineers'},
    {key: 'ENCON_FRPFN', text: 'ENCON FRP Fan Pvt. Ltd.'},
    {key: 'ENCON_INTNL', text: 'ENCON International'},
    {key: 'ENCON_COLTW', text: 'ENCON Cooling Towers Pvt. Ltd.'},
    {key: 'ENCON_FANIN', text: 'ENCON Fan (India) Pvt. Ltd.'}
];

export const rotorTypeArr = [
    {key: 'axial', text: 'Axial Flow'},
    {key: 'radial', text: 'Radial Flow'},
    {key: 'mixed', text: 'Mixed Flow'}
];

export const applicationArr = [
    {key: 'cooling_tower', text: 'Cooling Tower'},
    {key: 'air_cooled_condensor', text: 'Air Cooled Condensor'},
    {key: 'heat_exchanger', text: 'Heat Exchanger'},
    {key: 'exhaust', text: 'Exhaust'},
    {key: 'ventilation', text: 'Ventilation'},
    {key: 'min_ventilation', text: 'Mine Ventilation'},
    {key: 'withering_trough', text: 'Withering Trough'},
    {key: 'air_washer', text: 'Air Washer'},
    {key: 'blower', text: 'Blower'},
    {key: 'other', text: 'Others'}
];

export const installationTypeArr = [
    {key: 'induced', text: 'Induced Draft'},
    {key: 'forced', text: 'Forced Draft'}
];

export const mountingOrientationArr = [
    {key: 'vertical-clock', text: 'Vertical - ClockWise'},
    {key: 'vertical-anticlocl', text: 'Vertical - Anti ClockWise'},
    {key: 'horizontal-clock', text: 'Horizontal - ClockWise'},
    {key: 'horizontal-anticlocl', text: 'Horizontal - Anti ClockWise'}
];

export const LDArr = [
    {key: 0.05, text: '0.5'},
    {key: 0.1, text: '0.1'},
    {key: 0.15, text: '0.15'}
];

export const motorClassificationArr = [
    {key: 'ie1', text: 'IE1'},
    {key: 'ie2', text: 'IE2'},
    {key: 'ie3', text: 'IE3'}
];

export const hubTypeArr = [
    {key: 'single_plate_fenner', text: 'Single Plate Fenner Brush'},
    {key: 'double_plate_fenner', text: 'Double Plate Fenner Brush'},
    {key: 'double_taper', text: 'Double Taper Brush'}
];

export const hubPlateMaterialArr = [
    {key: 'MS-HDG', text: 'MS-HDG'},
    {key: 'SS', text: 'SS'},
    {key: 'ALU-ALLOY', text: 'ALU-ALLOY'},
];

export const clampMaterialArr = [
    {key: 'SS', text: 'SS'},
    {key: 'ALU-ALLOY', text: 'ALU-ALLOY'},
    {key: 'EFRP', text: 'EFRP'},
];

export const bushMaterialArr = [
    {key: 'SGI', text: 'SGI'},
    {key: 'SS', text: 'SS'},
    {key: 'ALU-ALLOY', text: 'ALU-ALLOY'},
];

export const hardwareMaterialArr = [
    {key: 'HT', text: 'HT'},
    {key: 'SS', text: 'SS'},
];

export const inletTypeArr = [
    {key: 'ellipse', text: 'Ellipse'},
    {key: 'circular', text: 'Circular'},
    {key: 'slope', text: 'Slope'}
];

export const beamNoArr = [
    {key: 1, text: '1'},
    {key: 2, text: '2'},
    {key: 3, text: '3'},
    {key: 4, text: '4'}
]

export const curveSrcArr = [
    {key: 'Test', text: 'Test'},
    {key: 'Legacy', text: 'Legacy'},
    {key: 'All', text: 'All (Test & Legacy)'}
];

export const driveTypeArr = [
    {key: 'Direct Drive', text: 'Direct Drive'},
    {key: 'Gear Box', text: 'Gear Box'},
    {key: 'V-Belt & Pulley', text: 'V-Belt & Pulley'}
];

export const bladeMaterialArr = [
    {key: 'EFRP', text: 'EFRP'},
    {key: 'CFRP', text: 'CFRP'},
];

export const gaHeadingArr = [
    {key: 'GENERAL ARRANGEMENT DRAWING OF FRP FAN ASSEMBLY FOR COOLING APPLICATION', text: 'GENERAL ARRANGEMENT DRAWING OF FRP FAN ASSEMBLY FOR COOLING APPLICATION'},
    {key: 'GENERAL ARRANGEMENT DRAWING OF FRP FAN ASSEMBLY FOR COOLING TOWER APPLICATION', text: 'GENERAL ARRANGEMENT DRAWING OF FRP FAN ASSEMBLY FOR COOLING TOWER APPLICATION'},
    {key: 'GENERAL ARRANGEMENT DRAWING OF FRP FAN ASSEMBLY FOR AIR COOLED CONDENSORS', text: 'GENERAL ARRANGEMENT DRAWING OF FRP FAN ASSEMBLY FOR AIR COOLED CONDENSORS'}
];

export const gaMaterialsArr = [
    {key: 'SS', text: 'SS'},
    {key: 'MS', text: 'MS'},
    {key: 'FRP', text: 'FRP'},
    {key: 'CFRP', text: 'CFRP'},
    {key: 'ALU', text: 'ALU'}
];

//FORM INPUT STRUCTURE

export interface ProjectDetailsFormInputs{
    customer_name: string,
    consultant: string,
    location: string,
    project: string,
    offer_number: string,
    po_number: number,
    unit: string,
    company_name: string,
    project_number: string,
    draft_project_number: string
};

export interface FanDetailsFormInput{
    rotor_type: string,
    fan_diameter: number,
    blade_no: number,
    fan_speed: number,
  
    application: string,
    install_type: string,
    mounting_orientation: string,
    air_density: number,
    rh: number,
    inlet_temp: number,
    minimum: number,
    maximum: number,
    altitude: number,
  
    req_airflow: number,
    pressure: number,
    pressure_type: string,
  
    tips_speed_limit: number,
    inlet_type: string,
    beam_no: number,
    venturi_height: number,
    angle: number,
    lnd: number,
  
    motor_classification: string,
    motor_eff: number,
    hub_type: string,
    hub_plate_material: string,
    clamp_material: string,
    bush_material: string,
    hardware_material: string,
  
    fan_ring_diameter: number,
    set_no: number,
    atmosphere_type: string,
    barometric_pressure: number,
    diffuser_eff: number,
    ga_drawing_id: string,
    discharge_dia: number,
    transmission_eff: number,
    hub_diameter: number,
    motor_rating: number,
    motor_rpm: number,
    fan_rpm: number,
    sound_power_cf: number,
    cont_unbalance_mass: number,
    blade_cog_ratio: number,
    min_pressure_margin: number,
    min_airflow_margin: number,
    curve_src: string,
    octave_band_id: string,
    blade_model: string,
    hub_id: string,
    drive_type: string,
    blade_material: string,
    transmission_efficiency: string,
    hub_bore_diameter: number,
    keyway: string,
};

export interface GADrawingFormInputs{
    name: string,
    application: string,
    location: string,
    make: string,
    model_number: string,
    part_number: string,
    fan_diameter: number,
    no_of_blades: number,
    fan_rpm: number,
    fan_drive: number,
    gearbox_model_no: string,
    reduction_ratio: string,
    motor_power: string,
    motor_rpm: string,
    qty: number,
    item_code_no: string,

    hub_spool_mat: string,
    hub_plate_mat: string,
    clamp_mat: string,
    clamp_hardware_mat: string,
    hub_spool_hardware_mat: string,
    blades_mat: string,

    hub_spool_spec: string,
    hub_plate_spec: string,
    clamp_spec: string,
    clamp_hardware_spec: string,
    hub_spool_hardware_spec: string,
    blades_spec: string,
    
    hub_spool_qty: string,
    hub_plate_qty: string,
    clamp_qty: string,
    clamp_hardware_qty: string,
    hub_spool_hardware_qty: string,
    blades_qty: string,


    client: string,
    client_location: string,
    po_number: string,
    po_date: string,
    ga_heading: string,
    drawing_number: string,
    ga_drawing_date: string,
    unit: string,
    company_name: string,

    dimension_a: number,
    dimension_b: number,
    dimension_c: number,
    dimension_d: number,
    dimension_e: number,
    dimension_f: number,
    dimension_g: number,
};


